// $(document).ready(function () {
//   $('.badges-slider').each(function () {
//     var $slider = $(this);
//     var slidesToShowDesktop = $slider.data('slides-to-show-desktop');
//     var slidesToShowTablet = $slider.data('slides-to-show-tablet');
//     var slidesToShowMobile = $slider.data('slides-to-show-mobile');

//     var numberOfItems = $slider.find('.badge-image').length;

//     var customSlickOptions = {
//       infinite: true,
//       accessibility: true,
//       arrows: true,
//       dots: true,
//       autoplay: false,
//       slidesToShow: slidesToShowDesktop,
//       slidesToScroll: 1,
//     };

//     customSlickOptions.responsive = [
//       {
//         breakpoint: 1024, // Tablet
//         settings: {
//           slidesToShow: slidesToShowTablet,
//         }
//       },
//       {
//         breakpoint: 767, // Mobile
//         settings: {
//           slidesToShow: slidesToShowMobile,
//         }
//       }
//     ];

//     // Initialize the Slick slider
//     if (numberOfItems >= slidesToShowDesktop) {
//       $slider.slick(customSlickOptions);
//     } else {
//       $slider.addClass('slick-deactivated');
//     }

//     // Function to refresh the slider's dimensions and recalculate height
//     function refreshSlider() {
//       $slider.slick('refresh');
//     }

//     // Call refreshSlider on window resize
//     $(window).on('resize', refreshSlider);

//     // Accessibility setup
//     $slider.on('init', function (event, slick) {
//       var $list = slick.$list;
//       var $wrapper = $slider.parent();

//       $list.removeAttr('aria-live');

//       $wrapper.on('focusin', function (evt) {
//         if ($wrapper.has(evt.target).length) {
//           $list.attr('aria-live', 'polite');
//         }
//       });

//       $wrapper.on('focusout', function (evt) {
//         if ($wrapper.has(evt.target).length) {
//           $list.removeAttr('aria-live');
//         }
//       });
//     });
//   });
// });


const COMPONENT_NAME = "text-image-carousel"
// Check if the custom element is already defined
if (!customElements.get(COMPONENT_NAME)) {
  const flickityDefaults = {
    adaptiveHeight: false,
    avoidReflow: true,
    pageDots: true,
    prevNextButtons: true,
    wrapAround: true,
    contain: true,
    cellAlign: "left",
    // lazyLoad: true
  };

  class TextImageCarousel extends HTMLElement {
    constructor() {
      super();
      const carouselElementId = this.getAttribute("container-id");
      this.singleSlide = this.getAttribute("single-slide");
      if (!carouselElementId) {
        throw new Error(
          `[${COMPONENT_NAME}] container-id must be defined.`
        );
      }
      this.carouselElement = this.querySelector("#" + carouselElementId)
    }

    connectedCallback() {
      if (!this.carouselElement) {
        throw new Error(
          `[${COMPONENT_NAME}] carouselElement not defined.`
        );
      }
      const _isSingleSlide = this.singleSlide;
      const flkty = new Flickity(this.carouselElement, {
        ...flickityDefaults,
        ...(_isSingleSlide === "true" ? {
          wrapAround: false
        } : {})
      });
      flkty.resize();
    }
  }

  // Define the new element
  customElements.define(COMPONENT_NAME, TextImageCarousel);
}